module.exports = __webpack_public_path__ + "static/img/plan4.c1f07cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/plan4.png
// module id = qGjI
// module chunks = 1